<template>
  <div>
    <DialogBase
      v-model="inputedValue.dialog"
      :title="dialogTitle"
      width="540"
      isPadding0="true"
    >
      <v-card class="pa-4">
        <div v-if="isShowAccountList" class="invoice-dialog-list">
          <div v-for="item in checkList" :key="item.id">
            <div class="invoice-dialog-account">
              <v-checkbox
                class="invoice-dialog-check"
                v-model="item.isCheck"
                hide-details
                :label="item.name"
              ></v-checkbox>
            </div>
          </div>
        </div>
        <div v-else-if="isShowInput">
          <div class="invoice-dialog-input-area">
            <div class="invoice-dialog-input-label">
              {{ $t('refund.refund_refund-management-number') }}
            </div>
            <v-text-field
              v-model="refundControlNumberStr"
              class="invoice-dialog-input"
              :placeholder="$t('common.input_input_1')"
              outlined
              hide-details
              clearable
            ></v-text-field>
          </div>
          <div class="invoice-dialog-input-caution">
            {{ $t('refund.refund_reflect-multiple-refunds-caution') }}
          </div>
        </div>
        <div v-else-if="isShowCombinedBill">
          <!-- 請求日 -->
          <div>
            <div class="invoice-dialog-input-label">
              {{ $t('sale.sale_bill-date') }}
              <RequiredLabel />
            </div>
            <div class="invoice-dialog-input-account-combined">
              <NormalDatePicker v-model="billDate" width="135px" />
            </div>
          </div>
          <!-- 支払期日 -->
          <div>
            <div class="invoice-dialog-input-label-combined">
              {{ $t('sale.sale_payment-limit-date') }}
              <RequiredLabel />
            </div>
            <div class="invoice-dialog-input-account-combined">
              <NormalDatePicker v-model="paymentLimitDate" width="135px" />
            </div>
          </div>
          <!-- 振込指定口座 -->
          <div class="invoice-dialog-input-label-combined">
            {{ $t('sale.sale_transfer-account') }}
          </div>
          <div v-for="item in checkList" :key="item.id">
            <div class="invoice-dialog-input-account-combined">
              <v-checkbox
                class="invoice-dialog-check"
                v-model="item.isCheck"
                hide-details
                :label="item.name"
              ></v-checkbox>
            </div>
          </div>
          <!-- 備考欄 -->
          <div class="invoice-dialog-input-label-combined">
            {{ $t('sale.sale_remarks-for-invoice') }}
          </div>
          <div class="invoice-dialog-input-textarea">
            <v-textarea
              v-model="note"
              class="invoice-dialog-input"
              :placeholder="$t('common.input_input_1')"
              outlined
              hide-details
            ></v-textarea>
          </div>
        </div>
        <div class="invoice-dialog-button">
          <NormalButton
            :text="$t('sale.sale_invoice-download')"
            width="475px"
            height="50px"
            textSize="16px"
            :disabled="isDisabledExecButton"
            @click="submit"
          />
        </div>
      </v-card>
    </DialogBase>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DialogBase from './DialogBase'
import NormalButton from '@/components/items/Buttons/NormalButton'
import NormalDatePicker from '@/components/items/inputs/NormalDatePicker'
import RequiredLabel from '@/components/items/Labels/RequiredLabel'
import { commonUtil } from '@/util'

export default {
  components: {
    DialogBase,
    NormalButton,
    NormalDatePicker,
    RequiredLabel
  },
  props: {
    value: {
      dialog: false
    }
  },
  data() {
    return {
      isFetching: false,
      checkList: [],
      type: '',
      refundControlNumberStr: '',
      billPeriodStart: '',
      billPeriodEnd: '',
      billDate: '',
      paymentLimitDate: '',
      note: ''
    }
  },
  async mounted() {
    this.isFetching = true
    await this.getTransferAccountListFromApi()
    this.isFetching = false
  },
  watch: {
    getTransferAccountListFromState() {
      if (this.type === 'account' || this.type === 'combinedBill') {
        this.initCheckList()
      }
    },
    isOpen() {
      this.type = this.inputedValue.type
      this.refundControlNumberStr = ''
      this.billDate = commonUtil.getToday()
      if (this.type === 'account' || this.type === 'combinedBill') {
        this.initCheckList()
      }
      if (this.type === 'combinedBill') {
        this.billPeriodStart = this.inputedValue.billPeriodStart
        this.billPeriodEnd = this.inputedValue.billPeriodEnd
      }
    }
  },
  computed: {
    ...mapGetters('TransferAccount', ['getTransferAccountListFromState']),
    isShowAccountList() {
      return !this.isFetching && this.type === 'account'
    },
    isShowInput() {
      return !this.isFetching && this.type === 'refund'
    },
    isShowCombinedBill() {
      return !this.isFetching && this.type === 'combinedBill'
    },
    isDisabledExecButton() {
      if (this.isShowAccountList) {
        const filteredList = this.checkList.filter((item) => item.isCheck)
        return this.isFetching || !filteredList.length
      }
      if (this.isShowInput) {
        return this.isFetching || !this.refundControlNumberStr
      }
      if (this.isShowCombinedBill) {
        return this.isFetching || !this.billDate || !this.paymentLimitDate
      }
      return true
    },
    dialogTitle() {
      if (this.type === 'combinedBill') {
        return 'sale.sale_combined-bill'
      }
      return this.type === 'account'
        ? 'sale.sale_transfer-account-designation-invoice'
        : 'sale.sale_refund-history-designation-invoice'
    },
    isOpen() {
      return this.inputedValue.dialog
    },
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    ...mapActions('TransferAccount', ['getTransferAccountListFromApi']),
    ...mapActions('CombinedBill', ['getCombinedBillFromApi']),
    initCheckList() {
      this.checkList = []
      this.getTransferAccountListFromState.forEach((each) => {
        this.checkList.push({
          isCheck: false,
          name: each.name,
          transferAccountId: each.TransferAccountId,
          sortNumber: each.sortNumber
        })
      })
    },
    getSaleIdsPath() {
      let saleIdsPath = ''
      if (!this.inputedValue.items.length) {
        const { saleId } = this.inputedValue.items
        saleIdsPath = `saleIds=${saleId}`
      } else {
        const ids = this.inputedValue.items.map((d) => d.id).join(',')
        saleIdsPath = `saleIds=${ids}`
      }
      return saleIdsPath
    },
    getSaleIdsPathForCombinedBill() {
      let saleIdsPath = ''
      if (!this.inputedValue.items.length) {
        const { saleId } = this.inputedValue.items
        saleIdsPath = saleId
      } else {
        const ids = this.inputedValue.items.map((d) => d.id).join(',')
        saleIdsPath = ids
      }
      return saleIdsPath
    },
    getAccountSpecifiedInvoice() {
      const saleIdsPath = this.getSaleIdsPath()
      const filteredList = this.checkList.filter((item) => item.isCheck)
      const transferAccountIds = filteredList
        .map((item) => item.transferAccountId)
        .join(',')
      const transferAccountIdsPath = `transferAccountIds=${transferAccountIds}`
      const path = `${this.inputedValue.submitPath}?${saleIdsPath}&${transferAccountIdsPath}`
      this.inputedValue.submitFunc(path)
    },
    getInvoiceWithRefundSpecified() {
      const saleIdsPath = this.getSaleIdsPath()
      const refundControlNumbersPath = `refundControlNumbers=${this.refundControlNumberStr}`
      const path = `${this.inputedValue.submitPath}?${saleIdsPath}&${refundControlNumbersPath}`
      this.inputedValue.submitFunc(path)
    },
    async getCombinedBill() {
      const saleIdsPath = this.getSaleIdsPathForCombinedBill()
      const filteredList = this.checkList.filter((item) => item.isCheck)
      const transferAccountIds = filteredList
        .map((item) => item.transferAccountId)
        .join(',')
      if (
        await this.getCombinedBillFromApi({
          saleIds: saleIdsPath,
          transferAccountId: transferAccountIds,
          billDate: this.billDate,
          billPeriodStart: this.billPeriodStart,
          billPeriodEnd: this.billPeriodEnd,
          paymentLimitDate: this.paymentLimitDate,
          note: this.formatTextWithLineBreaks(this.note)
        })
      ) {
        alert(this.$t('common.common_ledger-sheet-big-data-alert'))
      }
    },
    formatTextWithLineBreaks(text) {
      if (!text) return '';
      return text.replace(/\n/g, '\r\n')
    },
    submit() {
      if (this.type === 'account') {
        this.getAccountSpecifiedInvoice()
      } else if (this.type === 'refund') {
        this.getInvoiceWithRefundSpecified()
      } else {
        this.getCombinedBill()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.invoice-dialog {
  &-list {
    padding: 0 16px 30px 16px;
  }

  &-check {
    max-width: 500px;
  }

  &-input {
    margin-left: 20px;

    &-area {
      margin-top: 20px;
      padding: 0 16px 30px 16px;
      display: flex;
    }

    &-textarea {
      padding: 0 16px 30px 0;
      display: flex;
    }

    &-label {
      line-height: 32px;
      padding-top: 2px;
    }

    &-label-combined {
      line-height: 32px;
      padding-top: 16px;
    }

    &-caution {
      padding: 0 16px 30px 16px;
    }

    &-account-combined {
      padding: 0 16px 0 16px;
    }
  }

  &-button {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}

::v-deep {
  .v-text-field .v-input__append-inner {
    margin-top: 6px !important;
  }
  .theme--light.v-input input {
    padding-top: 12px !important;
  }
}
</style>
